import * as React from "react";
import { drawPixelated, getImageData } from "./utils";

interface IRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

interface IPixelImageProps {
  image: HTMLImageElement;
  scale?: number;
  crop?: IRect;
}

export const PixelImage = ({
  image,
  crop = { x: 0, y: 0, width: 0, height: 0 },
  scale = 1,
}: IPixelImageProps) => {
  const canvasElem = React.useRef<HTMLCanvasElement>(null);
  const { naturalWidth, naturalHeight } = image;
  const width = crop.width || naturalWidth;
  const height = crop.height || naturalHeight;

  React.useEffect(
    () => {
      const imageData = getImageData(
        image,
        crop.x || 0,
        crop.y || 0,
        crop.width || width,
        crop.height || height
      );
      const ctx = canvasElem.current.getContext("2d");
      ctx.clearRect(0, 0, width * scale, height * scale);
      drawPixelated(ctx, imageData, scale);
    },
    [crop.height, crop.width, crop.x, crop.y, height, image, scale, width]
  );

  return (
    <canvas width={width * scale} height={height * scale} ref={canvasElem} />
  );
};
